export const exclusionPatterns = [
	new RegExp("/documents/")
];